import React from 'react';
import classname from 'classnames';
import FormElement from "../FormElement.js";

export class RadioButtonGroup extends FormElement {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            selected: props.defaultSelected
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({
            selected: event.target.value
        });
        super.handleChange(event);
    }

    render() {
        return (
            <div>
                {
                    this.props.children.map((Child) => React.cloneElement(Child, {
                        onChange: this.handleChange,
                        name: this.props.name,
                        selected: Child.props.value === this.state.selected,
                        key: Child.props.value
                    }))
                }
            </div>
        );
    }
}